import { EventContext, Fields } from '@vimeo/bigpicture-client';

const collectionsBpContextName = 'collections_context';
const collectionsBpContextSchemaVersion = 4;
export type CollectionBpContext = Fields<
  typeof collectionsBpContextName,
  typeof collectionsBpContextSchemaVersion
>;

export const buildCollectionBpContext = (fields: CollectionBpContext) => {
  return {
    collections_context: new EventContext(
      collectionsBpContextName,
      collectionsBpContextSchemaVersion,
      fields,
    ),
  };
};
